<template>
  <div>

    <router-link
      :to="{name: 'master-unit-list'}"
      class="text-decoration-none text-white"
    >
      <b-button
        class="mb-1"
        variant="primary"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          class="mr-75"
        />
        Kembali
      </b-button>
    </router-link>
    <b-card>
      <!-- required required Wajib diisi -->
      <!-- min:x min:3 Minimal x karakter -->
      <!-- max:x max:10 Maksimal x karakter -->
      <!-- email email Format email valid -->
      <!-- numeric numeric Hanya angka -->
      <!-- between:x,y between:1,10 Antara nilai x dan y -->
      <!-- confirmed confirmed:password Cocok dengan field lain -->
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <!-- Nama Kategori -->
            <b-col cols="12">
              <b-form-group
                label="Nama Satuan"
                label-for="unit"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Satuan"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Masukkan Nama Satuan"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider></b-form-group>
            </b-col>

            <!-- Description -->
            <b-col cols="12">
              <b-form-group
                label="Keterangan"
                label-for="desc"
                label-cols-md="4"
              >
                <b-form-input
                  id="desc"
                  v-model="desc"
                />
              </b-form-group>
            </b-col>

            <!-- Tombol Aksi -->
            <b-col
              md="8"
              offset-md="4"
            >
              <b-button
                type="submit"
                variant="success"
                class="mr-1"
                @click.prevent="validationForm"
              >
                Simpan
              </b-button>
              <b-button
                type="reset"
                variant="outline-secondary"
              >
                Reset
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer></b-card>

  </div>
</template>

<script>
import {
  BFormInput, BFormGroup, BRow, BCol, BButton, BCard, BForm,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
// eslint-disable-next-line import/no-cycle
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BRow,
    BForm,
    BCol,
    BButton,
    BCard,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      name: null,
      desc: null,
      required,
    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {
    submitProduct() {
      const payload = {
        name: this.name,
        desc: this.desc,
      }

      console.log(payload)

      this.$http.post('/unit/add', payload)
        .then(() => {
          this.$bvToast.toast('Satuan berhasil ditambahkan!', {
            title: 'Sukses',
            variant: 'success',
            solid: true,
          })
          // Reset redirect
          this.$router.push({ name: 'master-unit-list' })
        })
        .catch(err => {
          console.error(err)
          this.$bvToast.toast('Gagal menambahkan Satuan.', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitProduct()
        } else {
          this.$bvToast.toast('Lengkapi Data Sebelum Submit!', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        }
      })
    },
  },
}
</script>
